import { Component, OnInit } from '@angular/core';
import { AbstractControl, NonNullableFormBuilder } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Exception } from '@cargos/sprintpay-models';
import { CustomPatterns, CustomValidators } from '@cargos/sprintpay-utils';
import { finalize, take } from 'rxjs';
import { PaymentConfirmationService } from 'src/app/shared/services';
import { EmailFormErrorJSON, EmailFormGroupType } from './models/customer-reference-form';
import { formEmailErrors } from './utils/form-errors';

@Component({
    selector: 'app-confirmation-alliance',
    templateUrl: './confirmation-alliance.component.html',
    styleUrls: ['./confirmation-alliance.component.scss'],
    standalone: false,
})
export class ConfirmationAllianceComponent implements OnInit {
    public emailForm: EmailFormGroupType;
    public formErrors: EmailFormErrorJSON;
    public isLoading = false;
    public durationInSeconds = 5;

    get email(): AbstractControl<string> | null {
        return this.emailForm.get('email');
    }

    constructor(
        private fb: NonNullableFormBuilder,
        private paymentConfirmationService: PaymentConfirmationService,
        private matSnackBar: MatSnackBar
    ) {
        this.formErrors = formEmailErrors;
    }

    ngOnInit(): void {
        this.createForm();
    }

    createForm(): void {
        this.emailForm = this.fb.group({
            email: ['', [CustomValidators.regex(new RegExp(CustomPatterns.EMAIL))]],
        });
    }

    sendEmail(): void {
        if (!this.email?.value || this.emailForm.invalid || this.isLoading) {
            return;
        }

        this.isLoading = true;
        this.paymentConfirmationService
            .sendNotificationEmail(this.email.value, 'SPRINTPASS_RESERVATION')
            .pipe(
                take(1),
                finalize(() => (this.isLoading = false))
            )
            .subscribe({
                next: (response) => {
                    this.openSnackBar(response?.message);
                },
                error: (err: Exception) => {
                    this.openSnackBar(err?.description);
                },
            });
    }

    openSnackBar(message: string): void {
        this.matSnackBar.open(message, 'Close', {
            duration: 3000,
            horizontalPosition: 'end',
        });
    }
}
